import { __rest } from 'tslib';
import React from 'react';
import { space } from 'styled-system';
import { s as styled } from './styled-112a8bd0.js';

const StyledCol = styled.div(({ col }) => {
    if (!col) {
        return {
            flex: '1 0 0%',
            minWidth: 0,
        };
    }
    return {
        flex: '0 0 auto',
        width: `${(col / 12) * 100}%`,
        paddingRight: '0.5rem',
        paddingLeft: '0.5rem',
    };
}, space);
const Col = (_a) => {
    var { children, col } = _a, props = __rest(_a, ["children", "col"]);
    return (React.createElement(StyledCol, Object.assign({ col: col }, props), children));
};

export { Col as C };
